import { useTheme } from '@mui/material';

export const SecureIconImage = () => {
    const theme = useTheme();
    const stroke = theme.colors.palette.secondary.main;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={39} height={40} fill="none">
            <path
                fill={stroke}
                d="M17.48.402a5.04 5.04 0 0 1 3.948 0l13.955 5.924c1.737.735 3.032 2.448 3.024 4.517-.04 7.834-3.254 22.168-16.869 28.683a4.824 4.824 0 0 1-4.169 0 28.067 28.067 0 0 1-5.29-3.289l.99-.83a26.824 26.824 0 0 0 4.845 2.982 3.567 3.567 0 0 0 3.08 0c12.967-6.208 16.11-19.917 16.15-27.546.007-1.516-.94-2.788-2.251-3.349L20.938 1.571a3.781 3.781 0 0 0-2.961 0l-.008-.008L4.015 7.486c-1.311.561-2.26 1.84-2.251 3.349.029 5.584 1.72 14.425 7.71 21.201l-.97.814C2.26 25.77.529 16.57.5 10.843.492 8.773 1.787 7.06 3.524 6.326L17.48.402ZM26.585 14.5a.634.634 0 0 1 .892 0 .634.634 0 0 1 0 .892l.008.007-10.108 10.11a.635.635 0 0 1-.893 0l-5.054-5.055a.634.634 0 0 1 0-.893.634.634 0 0 1 .892 0l4.605 4.605 9.658-9.666Z"
            />
        </svg>
    );
};
